import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BIModulesService } from '../../bi-modules.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { data } from 'jquery';
import { PageChangeEvent } from '@progress/kendo-angular-pager';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
@Component({
  selector: 'lib-bi-modal',
  templateUrl: './bi-modal.component.html',
  styleUrls: ['./bi-modal.component.scss']
})
export class BIModalComponent {
opened = false;
selectedRows: any[] = [];
totalDataLength: number = 0;
SelectAllValue: boolean = false;
  constructor(
    public biService: BIModulesService, public dialogRef: MatDialogRef<BIModalComponent>,
    @Inject(MAT_DIALOG_DATA) public Parentdata: any, private messages: MessageService) {
      this.messages.notify(this.biService.getDir());
      this.Parentdata.data$.subscribe((res: any)=>{
        this.totalDataLength = res.total;
      });
    }
  onNoClick(): void {
    //this.dialogRef.close();
  }
  CloseDialog(){
    this.Parentdata.Cancel()
    this.dialogRef.close();
  }
  OK(){
    // const selectedRows = this.Parentdata.data$.getValue().filter((item: { selected: any; }) => item.selected);
    this.Parentdata.multiSelectedRows = this.selectedRows;
    if (this.Parentdata.SelectedRow || this.Parentdata.multiSelectedRows) {
    this.Parentdata.Ok();
    this.dialogRef.close();
  }
  }
  onCheckboxChanged(dataItem: { selected: any; ID: string }) {
    if (dataItem.selected) {
      this.selectedRows = [...this.selectedRows , dataItem];
    }
    else{
      this.selectedRows =  this.selectedRows.filter(item=>item[this.Parentdata.Key]!== (dataItem as any)[this.Parentdata.Key])
        
    }
  }
  
  public Kendofilter: CompositeFilterDescriptor = {
    logic: 'and',
    filters: [],
  };
  public onPageChange(e: any): void {
      e.filter = this.Kendofilter;
      this.Parentdata.FilterChange(e);
  }
  public FilterChange(state: any): void {
    this.Kendofilter = state.filter;
    this.Parentdata.FilterChange(state);
  }

   // dialog 
   public openedError = false;
   public DialogText!:string;
 
   public close(status: string): void {
       this.openedError = false;
   }
 
   public open(event:any,res:any,data:any): void {
     let currentSelectedItem = res.Name;
     this.DialogText = data[currentSelectedItem]
 
       this.openedError = true;
   }
 
   public ChangeSelectAll(event:any){
      this.selectedRows = [];
      if(event.returnValue){
        this.selectedRows = [...this.Parentdata.DataSource?.data?.data];
      }
      //loop on 
      
   }
 
}
